<template>
  <a-modal
    v-model="visible"
    title="Custom Plan Invitation"
    :destroyOnClose="true"
    :width="'75%'"
  >
    <a-form-model
      ref="customPlanForm"
      :model="customPlan"
      :rules="rules"
      layout="vertical"
    >
      <a-row :gutter="16" class="vertical-center">
        <a-col :span="8">
          <a-form-model-item label="Plan" prop="subscriptionPlanId">
            <a-select
              placeholder="Plan"
              v-model="customPlan.subscriptionPlanId"
              style="width: 100%"
            >
              <a-select-option v-for="p in plans" :key="p.id" :value="p.id">
                {{ p.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item
            label="Price (VAT inclusive)"
            prop="overridedPrice"
          >
            <a-input-number
              class="width-100"
              placeholder="Price"
              :min="1"
              v-model="customPlan.overridedPrice"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="Expiry Date" prop="expiryDate">
            <DateTimePickr
              :date="customPlan.expiryDate"
              @onChange="onExpiryDateChanged"
            ></DateTimePickr>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16" class="vertical-center">
        <a-col :span="8">
          <a-form-model-item label="Client's first name" prop="clientName">
            <a-input
              class="width-100"
              placeholder="Name"
              v-model="customPlan.clientName"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="Email" prop="emailAddress">
            <a-input
              class="width-100"
              placeholder="Email"
              v-model="customPlan.emailAddress"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <div>
            <a-checkbox v-model="customPlan.isSkipPayment">
              Skip Payment
            </a-checkbox>
          </div>
        </a-col>
      </a-row>
    </a-form-model>
    <template #footer>
      <a-button type="primary" @click="sendInvitation" :loading="isLoading"
        >Send Invitation</a-button
      >
      <a-button @click="cancel">Cancel</a-button>
    </template>
  </a-modal>
</template>
<script>
import { invitationsMutations } from "../../Store/store.js";
import moment from "moment";
import { helper } from "../../Utilities/helper";

export default {
  props: {
    value: Boolean,
    plans: {
      type: Array,
      defualt: () => [],
    },
    channelId: {
      type: Number,
      defualt: () => null,
    },
  },
  data() {
    return {
      invitationsMutations,
      customPlan: {
        expiryDate: moment().add(2, "days").format("DD/MM/YYYY"),
      },
      rules: {
        overridedPrice: [
          { required: true, message: "Please input a price", trigger: "blur" },
        ],
        emailAddress: [
          { required: true, message: "Please input an email", trigger: "blur" },
          { validator: helper.emailValidator, trigger: "blur" },
        ],
        subscriptionPlanId: [
          {
            required: true,
            message: "Please select a Plan",
            trigger: "change",
          },
        ],
        clientName: [
          {
            required: true,
            message: "Please put the client's first name",
            trigger: "change",
          },
        ],
        expiryDate: [
          {
            required: true,
            message: "Please put the expiry date",
            trigger: "change",
          },
        ],
      },
      isLoading: false,
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.customPlan = {
          expiryDate: moment().add(2, "days").format("DD/MM/YYYY"),
        };
      },
    },
  },
  methods: {
    async sendInvitation() {
      this.$refs.customPlanForm.validate(async (valid) => {
        if (valid) {
          try {
            this.customPlan.url = `${window.location.protocol}//${window.location.host}/signup.html`;
            this.customPlan.channelId = this.channelId;
            this.isLoading = true;
            await invitationsMutations.addInvitation(this.customPlan);
            this.$message.success("Invitation successfully sent!");
          } catch (e) {
            this.$message.error("Error while sending invitation!");
          } finally {
            this.isLoading = false;
            this.cancel();
          }
        }
      });
    },
    onExpiryDateChanged(dateVal) {
      this.isDateChanged = true;
      this.customPlan.expiryDate = dateVal;
    },
    cancel() {
      this.visible = false;
    },
  },
};
</script>
<style scoped>
.vertical-center {
  display: flex;
  align-items: center;
}
</style>
